// core
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

// share
import { IBreadcrumb } from '@shared/data-access/interfaces';

@Component({
  selector: 'red-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  @Input() breadcrumbList: IBreadcrumb[] = [];
}
